import { useEffect } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { LEGAL } from "../lib/legal";
import { setSeo } from "../lib/seo";

export default function LegalPage({ doc }) {
  const data = LEGAL[doc];

  useEffect(() => {
    if (data) setSeo({ title: `${data.title} · Marella Bolognesi`, description: data.intro.slice(0, 155) });
  }, [data]);

  if (!data) {
    return (
      <div className="pt-40 pb-40 text-center">
        <p className="text-ink-soft">Document not found.</p>
      </div>
    );
  }

  return (
    <div data-testid={`legal-${data.slug}-page`} className="pt-24 lg:pt-32 pb-28">
      <div className="mx-auto max-w-[820px] px-6 lg:px-8">
        <p className="text-[11px] uppercase tracking-ultra text-accent">Legal</p>
        <h1 className="mt-5 font-serif font-light text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
          {data.title}
        </h1>
        <p className="mt-4 text-xs uppercase tracking-[0.2em] text-ink-soft">Last updated: {data.updated}</p>
        <p className="mt-8 text-lg font-light text-ink-soft leading-relaxed">{data.intro}</p>

        <div className="mt-14 space-y-12">
          {data.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-serif font-light text-2xl lg:text-3xl text-ink">{s.h}</h2>
              <div className="mt-4 space-y-4">
                {s.p.map((para, j) => (
                  <p key={j} className="text-base font-light text-ink-soft leading-relaxed">{para}</p>
                ))}
              </div>
              {s.decision && (
                <div data-testid={`legal-decision-${i}`} className="mt-6 flex gap-3 border border-[#c9a24b]/50 bg-[#c9a24b]/10 px-5 py-4">
                  <AlertTriangle size={18} className="text-[#9a7a2e] shrink-0 mt-0.5" strokeWidth={1.6} />
                  <p className="text-sm font-light text-[#6b5620] leading-relaxed">{s.decision}</p>
                </div>
              )}
            </section>
          ))}
        </div>

        <div className="mt-16 border-t border-line pt-10">
          <p className="text-sm font-light text-ink-soft">
            This is a draft for review and is not legal advice. Please have it confirmed by a qualified professional before publishing.
          </p>
          <Link to="/contact" className="mt-5 inline-block text-[11px] uppercase tracking-[0.2em] text-ink link-underline">Contact us</Link>
        </div>
      </div>
    </div>
  );
}
